<template>
    <div v-if="videoList.length > 0" style="margin-top: 10px;">
      <div class="video bot">
        <div class="item" v-for="item in videoList" :key="item.id" @click="goDetail(item)">
          <div>
            <img style="width: 180px;height: 100px;" :src="filterImage(item.poster, 172, 109)" />
            <img src="@/assets/images/match_icon_play.png" class="icon" />
          </div>
          <p class="overflow-text-two">{{ item.title }}</p>
        </div>
        <div style="width: 160px;"></div>
      </div>
      <div class="more" @click="goList">更多视频</div>
    </div>
</template>

<script>
import { QNImageUtil } from '@/utils'
export default {
  props: {
    videoList: {
      typeof: Array,
      default: () => []
    },
    match: {
      typeof: Object,
      default: {}
    },
  },
    data() {
        return {

        };
    },
    methods: {
      filterImage(img, w, h, mode) {
        return QNImageUtil.imageView(img, parseInt(2 * w, 10), parseInt(2 * h, 10), mode)
      },
      goDetail(obj) {
        if (process.env.NODE_ENV === 'development') {
          window.location.href = `https://www.snsports.cn/webapp-stage/main.html#/video-detail?objType=${obj.objType}&objId=${obj.objId}&videoId=${obj.videoId}`
        } else {
          window.location.href = `https://www.snsports.cn/webapp/index.html?redirect=video-detail&objType=${obj.objType}&objId=${obj.objId}&videoId=${obj.videoId}`
        }
      },
      goList() {
        const obj = this.videoList[0]
        if (process.env.NODE_ENV === 'development') {
          window.location.href = `https://www.snsports.cn/webapp-stage/main.html#/video-list?objType=${obj.objType}&matchId=${obj.objId}`
        } else {
          window.location.href = `https://www.snsports.cn/webapp/index.html?redirect=video-list&objType=${obj.objType}&matchId=${obj.objId}`
        }
      }
    },
};
</script>

<style scoped lang="scss">
  .video{
    padding: 10px 0;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    background-color: #fff;
    .item{
      width: 48%;
      font-size: 14px;
      img{
        width: 100%;
      }
      div{
        position: relative;
      }
      .icon{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        width: 40px;
        height: 40px;
      }
    }
  }
  .more{
    padding: 10px 0;
    text-align: center;
    font-size: 14px;
    color: #ababab;
    background: #fff;
    margin-bottom: 20px;
  }
  .bot{
  border-bottom: 2.5px solid #F8F8F8;
}
</style>
